import { Block } from '@aloft/toolkit-sui';

export const Divider = () => (
  <Block width="100%" borderTopWidth="1px" borderStyle="solid" borderColor="strokeDefault" />
);
